import { ARTICLE_PATHS } from './articleUrls'

export const ADDITIONAL_REQUIREMENTS = {
  // Experience Credits Card (shown for all users)
  EXPERIENCE_CREDITS: {
    id: 'experience_credits',
    title: 'Understanding Experience Credits',
    description: 'It is important to be aware of Experience Credits requirements, which will be reviewed when you apply for PGA of America Membership at the end of Level 3.',
    linkText: 'Learn More',
    linkUrl: ARTICLE_PATHS.EXPERIENCE_CREDITS
  },
  
  // Playing Ability Test Card (shown only when PAT is incomplete)
  PAT: {
    id: 'playing_ability_test',
    title: 'Playing Ability Test',
    description: 'Congratulations, you have received qualifying scores on your PAT. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.',
    primaryLinkText: 'Find a PAT',
    secondaryLinkText: 'View Guide',
    secondaryLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST
  }
}
